import React, { forwardRef } from 'react';
import { formatPrice, formatDate } from '../../utils/helpers';

const PaymentReceiptView = forwardRef(({ payment }, ref) => {
  if (!payment) return null;

  return (
    <div ref={ref} className="bg-white p-8 max-w-md mx-auto" style={{ fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <div className="text-center mb-6 pb-4 border-b-2 border-gray-200">
        <h1 style={{ fontFamily: 'Georgia, serif', fontSize: '24px', color: '#D4AF37', marginBottom: '4px' }}>
          Luster Adorn
        </h1>
        <p style={{ fontSize: '11px', color: '#666' }}>Premium Imitation Jewelry</p>
        <h2 style={{ fontSize: '18px', color: '#1A1A1A', marginTop: '16px', letterSpacing: '2px' }}>PAYMENT RECEIPT</h2>
      </div>

      {/* Receipt Details */}
      <div className="mb-6">
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
          <span style={{ fontSize: '12px', color: '#666' }}>Receipt No.</span>
          <span style={{ fontSize: '12px', color: '#333', fontWeight: '500' }}>PAY-{payment.id?.toString().padStart(6, '0')}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
          <span style={{ fontSize: '12px', color: '#666' }}>Date</span>
          <span style={{ fontSize: '12px', color: '#333' }}>{formatDate(payment.payment_date)}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
          <span style={{ fontSize: '12px', color: '#666' }}>Invoice No.</span>
          <span style={{ fontSize: '12px', color: '#333' }}>{payment.invoice_number}</span>
        </div>
      </div>

      {/* Customer */}
      <div className="mb-6 p-4" style={{ backgroundColor: '#f8f8f8' }}>
        <p style={{ fontSize: '11px', color: '#999', textTransform: 'uppercase', marginBottom: '4px' }}>Received From</p>
        <p style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>{payment.customer_name}</p>
        {payment.customer_phone && (
          <p style={{ fontSize: '12px', color: '#666' }}>{payment.customer_phone}</p>
        )}
      </div>

      {/* Amount */}
      <div className="mb-6 p-6 text-center" style={{ backgroundColor: '#f0fdf4', border: '2px solid #22c55e' }}>
        <p style={{ fontSize: '11px', color: '#16a34a', textTransform: 'uppercase', marginBottom: '4px' }}>Amount Received</p>
        <p style={{ fontSize: '32px', color: '#16a34a', fontWeight: 'bold' }}>{formatPrice(payment.amount)}</p>
      </div>

      {/* Payment Method */}
      <div className="mb-6">
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
          <span style={{ fontSize: '12px', color: '#666' }}>Payment Method</span>
          <span style={{ fontSize: '12px', color: '#333', textTransform: 'capitalize' }}>{payment.payment_method?.replace('_', ' ')}</span>
        </div>
        {payment.reference_number && (
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ fontSize: '12px', color: '#666' }}>Reference No.</span>
            <span style={{ fontSize: '12px', color: '#333' }}>{payment.reference_number}</span>
          </div>
        )}
      </div>

      {/* Notes */}
      {payment.notes && (
        <div className="mb-6 p-3" style={{ backgroundColor: '#fffbeb', borderLeft: '3px solid #D4AF37' }}>
          <p style={{ fontSize: '11px', color: '#92400e' }}>{payment.notes}</p>
        </div>
      )}

      {/* Signature */}
      <div className="mt-8 pt-6" style={{ borderTop: '1px dashed #ccc' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div>
            <div style={{ width: '150px', borderBottom: '1px solid #333', marginBottom: '4px' }}></div>
            <p style={{ fontSize: '10px', color: '#666' }}>Customer Signature</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ width: '150px', borderBottom: '1px solid #333', marginBottom: '4px', marginLeft: 'auto' }}></div>
            <p style={{ fontSize: '10px', color: '#666' }}>Authorized Signature</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{ marginTop: '32px', textAlign: 'center' }}>
        <p style={{ fontSize: '10px', color: '#999' }}>Thank you for your payment!</p>
        <p style={{ fontSize: '9px', color: '#ccc', marginTop: '4px' }}>This is a computer generated receipt.</p>
      </div>

      {/* Store Info */}
      <div style={{ marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #eee', textAlign: 'center' }}>
        <p style={{ fontSize: '10px', color: '#999' }}> Maharashtra, India • +91 94211 47643 • hello@lusteradorn.com</p>
      </div>

      {/* Print Styles */}
      <style>
        {`
          @media print {
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            @page { margin: 0.5in; size: A5; }
          }
        `}
      </style>
    </div>
  );
});

PaymentReceiptView.displayName = 'PaymentReceiptView';

export default PaymentReceiptView;
